{
/**
 * Wraps the ® symbol in a hidden span within a specific element.
 * @param {Node} rootNode - The element or text node to scan.
 */
const wrapTrademarkInNode = (rootNode) => {
    // Only process element or document nodes
    if (rootNode.nodeType !== Node.ELEMENT_NODE && rootNode.nodeType !== Node.DOCUMENT_NODE) return;

    const walker = document.createTreeWalker(
        rootNode,
        NodeFilter.SHOW_TEXT,
        null,
        false
    );

    const nodesToReplace = [];
    while (walker.nextNode()) {
        const node = walker.currentNode;
        // Avoid re-processing symbols already inside our hidden span
        // Exclude symbols inside .menu-item a
        if (
            node.textContent.includes('®') &&
            !node.parentElement.closest('span[aria-hidden="true"]') &&
            !node.parentElement.closest('.menu-item a')
        ) {
            nodesToReplace.push(node);
        }
    }

    nodesToReplace.forEach(node => {
        const parent = node.parentNode;
        if (!parent) return;

        const fragment = document.createDocumentFragment();
        const parts = node.textContent.split('®');

        parts.forEach((part, index) => {
            fragment.appendChild(document.createTextNode(part));
            if (index < parts.length - 1) {
                const span = document.createElement('span');
                span.setAttribute('aria-hidden', 'true');
                span.textContent = '®';
                fragment.appendChild(span);
            }
        });

        parent.replaceChild(fragment, node);
    });
};

// 1. Run once on the existing content
wrapTrademarkInNode(document.body);

// 2. Setup the Observer for future changes
const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            // Scan newly added elements
            wrapTrademarkInNode(node);
        });
    });
});

// Start watching the entire document for added children or subtree changes
observer.observe(document.body, {
    childList: true,
    subtree: true
});
}